import { AxiosResponseHeaders } from "axios";
import qs from "qs";
import { apiPrivateAxios, apiPrivateAxiosWithHeaders } from "../../axios";
import { IParams } from "../../../store/types/common";
import { IUsers } from "../../../store/users/types";
import {
  ICurrentUser,
  IUser,
  ICreateUser,
  IUpdateUser,
  IUserSelector,
} from "./types";
import { IGetParams } from "../../types";
import { signOut } from "aws-amplify/auth";
import { AUTH_PATHS } from "../../../pages/auth/routes/constants";
import { NavigateFunction } from "react-router-dom";
import {
  DEFAULT_ORDER,
  DEFAULT_SORTING_USERS,
  DEFAULT_PAGE_SIZE,
} from "../../../components/common/TopBar/TopBarActions/constants";
import { AUTO_LOGOUT_SECONDS } from "../../../constants/env";

export const usersRequests = {
  getCurrentUser: (): Promise<ICurrentUser> =>
    apiPrivateAxios.get("user/current"),
  getUser: (id: string): Promise<IUser> => apiPrivateAxios.get(`/user/${id}`),
  getUserCsv: (data: { [k: string]: string }): Promise<Blob> =>
    apiPrivateAxios.get("/user/batch?status=Active&status=Inactive", {
      params: { ...data, inactiveLast: true },
    }),
  createUser: (data: ICreateUser): Promise<ICreateUser> =>
    apiPrivateAxios.post("/user", data),
  updateUser: (id: string, data: IUpdateUser): Promise<IUpdateUser> =>
    apiPrivateAxios.put(`/user/${id}`, data),
  updateUserStatus: (data: { ids: string[]; status: string }): Promise<void> =>
    apiPrivateAxios.put("/user/status", data),

  updateUserRole: (id: string): Promise<void> =>
    apiPrivateAxios.post("/user/role", { id }),
  uploadUserCsv: (data: FormData): Promise<IUsers[]> =>
    apiPrivateAxios.post("/user/batch", data),
  getUsers: (
    params?: IParams
  ): Promise<{ data: IUsers[]; headers: AxiosResponseHeaders }> =>
    apiPrivateAxiosWithHeaders.get("/user?status=Active&status=Inactive", {
      params: {
        ...params,
        inactiveLast: true,
        size: params?.size || DEFAULT_PAGE_SIZE,
        sort: params?.sort || DEFAULT_SORTING_USERS,
        order: params?.order || DEFAULT_ORDER,
        total: true,
      },
    }),
  getUsersSelectors: (params: IGetParams = {}): Promise<IUserSelector[]> =>
    apiPrivateAxios.get("/user/selector", {
      params,
      paramsSerializer: (paramsData) =>
        // TODO: replace to the custom method (not use qs)
        qs.stringify(paramsData, { arrayFormat: "repeat" }),
    }),
  checkFacilityKeyExists: (facilityKey: string): Promise<boolean> => {
    const url = `/user/checkFacilityKeyExists?facilityKey=${facilityKey}`;
    return apiPrivateAxios.get(url);
  },
  logout: async (navigate?: NavigateFunction, message?: string) => {
    await signOut();
    localStorage.removeItem("user");
    localStorage.removeItem("facilityKey");
    localStorage.removeItem("autoLogoutExpiry");
    if (navigate) {
      navigate(`${AUTH_PATHS.AUTH}${AUTH_PATHS.LOGIN}`, { state: { message } });
      return;
    } else {
      window.location.href = `${AUTH_PATHS.AUTH}${AUTH_PATHS.LOGIN}`;
    }
  },
  slideAutoLogoutExpiry: () => {
    const epochNow = Math.floor(new Date().getTime() / 1000);
    localStorage.setItem(
      "autoLogoutExpiry",
      (epochNow + AUTO_LOGOUT_SECONDS).toString()
    );
  },
  getAutoLogoutExpiry: () => {
    return Number(localStorage.getItem("autoLogoutExpiry") ?? 0);
  },
};

export default { usersRequests };
